<template>
  <!-- viewBox="0 0 16 16" -->
  <path
    d="M5.00037 9.62273L5.00037 6.38509C5.00037 5.91742 5.58513 5.70573 5.8845 6.06502L7.23332 7.68384C7.38781 7.86926 7.38781 8.13856 7.23332 8.32397L5.8845 9.94279C5.58513 10.3021 5.00037 10.0904 5.00037 9.62273Z"
    fill="#B5BCC4"
  />
  <path
    d="M11.0009 6.38457L11.0009 9.62324C11.0009 10.0908 10.4162 10.3026 10.1168 9.9434L8.76689 8.32406C8.6123 8.13862 8.6123 7.8692 8.76689 7.68375L10.1168 6.06441C10.4162 5.70524 11.0009 5.91696 11.0009 6.38457Z"
    fill="#B5BCC4"
  />
  <path
    d="M11.5 3L4.5 3C3.67157 3 3 3.67157 3 4.5L3 11.5C3 12.3284 3.67157 13 4.5 13L11.5 13C12.3284 13 13 12.3284 13 11.5L13 4.5C13 3.67157 12.3284 3 11.5 3Z"
    stroke="#B5BCC4"
    stroke-width="1.5"
  />
</template>
